import CommonDP from './CommonDP';
import "@/styles/global.scss"
import { routeCustomizeFunc } from "@/router";
import customGlobalParams from "./customGlobalParams";
import { registerStdFlowForm } from "./views/flowComponents/flowFormRegister";
import "@/directives/resize"
import zip from '@/store/zip'
import docSort from '@/store/docSort'
const commonDP = new CommonDP({
  appTitle: '数字元景',
  appLogo: require("@/views/assets/logo.white.png"),
  headLogo: require("@/views/assets/logo.head.png"),
  showLogo: require("@/views/assets/logo.dark.png"),
  extention: {},
  globalParams: customGlobalParams, // 全局参数，功能实现参考src/CommonDP/utils/globalParams.js
  routeCustomizeFunc,
  storeCustomizeFunc: (storeConfig) => {
    // 实现对存储的自定义处理
    storeConfig.modules = {
      zip,
      docSort,
      ...storeConfig.modules
    }
    return storeConfig;
  },
});

commonDP.init().then(() => {
  registerStdFlowForm();
});
